// resilient-overlay-container.ts
import { Injectable } from '@angular/core';
import { OverlayContainer } from '@angular/cdk/overlay';

@Injectable()
export class ResilientOverlayContainer extends OverlayContainer {
  override getContainerElement(): HTMLElement {
    // If someone removed it from the DOM, recreate it
    if (
      !this._containerElement ||
      !document.body.contains(this._containerElement)
    ) {
      // @ts-expect-error private API behind the scenes, but safe here
      this._containerElement = undefined;
      this._createContainer();
    }
    return super.getContainerElement();
  }
}
